// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crop-image-preview[data-v-36edfe1d] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: 180px;\n  background: #f8fafc;\n  overflow: hidden;\n}\n.crop-image-preview__img[data-v-36edfe1d] {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n.crop-image-preview__placeholder[data-v-36edfe1d] {\n  color: #94a3b8;\n}\n", ""]);
// Exports
module.exports = exports;
